module.exports = __webpack_public_path__ + "static/img/4.e422881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zz/4.png
// module id = 6sjt
// module chunks = 1